import axios from 'axios';
import { CompanyInfo } from 'interfaces/components/dataEntryModal';

export const sendData = (dataEntry: CompanyInfo<number>) => {
  return axios.post('/api/sendData', { ...dataEntry });
};
